import { render, staticRenderFns } from "./WPRegionEdit.vue?vue&type=template&id=3d418420&scoped=true&"
import script from "./WPRegionEdit.vue?vue&type=script&lang=js&"
export * from "./WPRegionEdit.vue?vue&type=script&lang=js&"
import style0 from "./WPRegionEdit.vue?vue&type=style&index=0&id=3d418420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d418420",
  null
  
)

export default component.exports